import React from 'react'

import { Container, Content } from './styles'

export interface ModalFooterProps {
  className?: string
  children?: React.ReactNode
}

export const ModalFooter = ({ className, children }: ModalFooterProps) => {
  return (
    <Container className={className}>
      <Content>{children}</Content>
    </Container>
  )
}
